<template>
  <div class="video-card card">
    <div class="card__img center-child">
      <img :src="require(`@/assets/${backgroundUrl}`)" alt />
      <a target="_blank" :href="uri">
      <svg
      
        class="play-button"
        width="96"
        height="96"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        aria-hidden="true"
      >
        <defs>
          <path
            d="M48 0C21.504 0 0 21.504 0 48s21.504 48 48 48 48-21.504 48-48S74.496 0 48 0z"
            id="b"
          />
          <filter
            x="-37.5%"
            y="-37.5%"
            width="175%"
            height="175%"
            filterUnits="objectBoundingBox"
            id="a"
          >
            <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur stdDeviation="12" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
              in="shadowBlurOuter1"
            />
          </filter>
          <linearGradient x1="60.966%" y1="29.2%" x2="36.71%" y2="69.385%" id="c">
            <stop stop-color="#fc6767" offset="0%" />
            <stop stop-color="#ec008c" offset="100%" />
          </linearGradient>
        </defs>
        <g fill-rule="nonzero" fill="none">
          <use fill="#000" filter="url(#a)" xlink:href="#b" />
          <use fill="#FFF" xlink:href="#b" />
          <path fill="url(#c)" d="M41 63V33l20 15z" />
        </g>
      </svg>
      </a>
    </div>
    <div class="card__description">
      <div class="aniket965--subtitle">{{title}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VideoCard",
  props: {
    title: String,
    uri:String,
    backgroundUrl:String

  }
};
</script>

<style lang="scss" scoped>
.video-card {
  width: 350px;
  max-width: 90%;
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out,
    -webkit-transform 0.3s ease-out, -webkit-box-shadow 0.3s ease-out;
  overflow: hidden;
  align-self: center;
  justify-self: center;
}
.card:hover {
  box-shadow: 0 8px 36px 0 rgba(10, 16, 34, 0.25), 0 0 0 transparent;
  transform: translateY(-6px) translateZ(0px);
}
.card__description {
  padding: 1rem;
}
.card__img {
  position: relative;
  height: 200px;
  max-width: 350px;
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.play-button {
  bottom: 0;
  z-index: 1;
  left: 0;
  margin: auto;
  overflow: visible;
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 0;
}
img {
  height: 200px;
  max-width: 350px;
  overflow: hidden;
  flex-shrink: 0;

  transition: -webkit-transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  will-change: transform;
}
.video-card:hover img {
  transform: scale(1.2);
  border-top-left-radius: 10px;
  border-top-right-radius: 20px;
}
.video-card:hover .card__description {
  background: #ec008c; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #fc6767,
    #ec008c
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #fc6767,
    #ec008c
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.video-card:hover .aniket965--subtitle {
  color: white;
}
</style>
